import React from "react";
import styles from "./styles.scss";
import { shouldUpdate, MergeStyles, ImageUtil } from "utils/index";
import SignatureCanvas from "react-signature-canvas";
import mediaservice from "services/media/mediaservice";
import config from "config/config";

class FormSig extends React.PureComponent {
	static defaultProps = {
		//any class added to the canvas must be wrapped in :global or added to the global css sheet (not hashed)
		signatureClass: ""
	};
	constructor(props) {
		super(props);
		this.ref = null;
		this._reinitialized = false;
	}
	render() {
		let {
			input,
			label,
			meta: { touched, error },
			className,
			...other
		} = this.props;

		//https://github.com/agilgur5/react-signature-canvas#props
		return (
			<div className={className} styleName="input-group">
				<div>{label}</div>
				<div styleName="__signature-root">
					<SignatureCanvas
						onEnd={x => {
							this._reinitialized = true;
							const img = this.ref.toDataURL();
							const file = mediaservice.dataURLtoFile(img, "sig.jpg");
							mediaservice.createFileLink(file).then(filelink => {
								input.onChange(filelink);
							});
						}}
						clearOnResize={true}
						ref={ref => {
							if (ref) {
								this.ref = ref;
								if (input.value && !this._reinitialized) {
									//if form is populated with existing data then insert exisitng sig image into canvas
									if (typeof input.value === "string") {
										this.ref.fromDataURL(input.value);
									} else if (input.value.amazonUrl) {
										ImageUtil.loadAsBlob(config.amazonUrl + input.value.amazonUrl).then(image => {
											ImageUtil.toDataUrl(image).then(url => this.ref.fromDataURL(url));
										});
									}

									this._reinitialized = true;
								}
							}
						}}
						canvasProps={{ width: 300, height: 150, className: `__input-signature ${this.props.signatureClass}` }}
					/>
				</div>
				{touched && error && <div styleName="_input-error">{error}</div>}
			</div>
		);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.input.value && !this.props.input.value && this.ref) {
			//clear the canvas if redux form was also cleared
			this.ref.clear();
		}
	}
}

export const RenderSignaturePad = MergeStyles(styles, { forwardRef: false })(FormSig);
